import type { ReactNode } from 'react';

import { cn } from '@/utils/cn';

import styles from './Card.module.css';

export interface CardProps {
  title?: ReactNode;
  description?: ReactNode;
  /** Buttons or links on the right of the header. */
  actions?: ReactNode;
  /** `flush` removes the body padding — for tables and lists that run edge to edge. */
  padding?: 'md' | 'flush';
  className?: string | undefined;
  bodyClassName?: string | undefined;
  children?: ReactNode;
}

export function Card({
  title,
  description,
  actions,
  padding = 'md',
  className,
  bodyClassName,
  children,
}: CardProps) {
  const hasHeader = title !== undefined || actions !== undefined;
  return (
    <section className={cn(styles.card, padding === 'flush' && styles.flushCard, className)}>
      {hasHeader && (
        <header className={styles.header}>
          <div className={styles.heading}>
            {title !== undefined && <h2 className={styles.title}>{title}</h2>}
            {description !== undefined && <p className={styles.description}>{description}</p>}
          </div>
          {actions !== undefined && <div className={styles.actions}>{actions}</div>}
        </header>
      )}
      {children !== undefined && (
        <div className={cn(styles.body, padding === 'flush' && styles.flush, bodyClassName)}>
          {children}
        </div>
      )}
    </section>
  );
}
